<template>
  <el-card>
    <el-form class="global-form2" label-width="120px">
      <el-form-item label="项目名称" prop="projectId">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item prop="contractName" label="合同名称">
        {{ formData.contractName }}
      </el-form-item>
      <el-form-item prop="startDate" label="开始日期">
        {{ formData.startDate }}
      </el-form-item>
      <el-form-item prop="endDate" label="结束日期">
        {{ formData.endDate }}
      </el-form-item>
      <el-form-item prop="contractAmount" label="合同总额">
        {{ formData.contractAmount }}
      </el-form-item>
      <el-form-item prop="maintainLevel" label="养护等级">
        {{ formData.maintainLevelName }}
      </el-form-item>
      <el-form-item class="plan" prop="planBackList" label="回款计划">
        <el-table :data="formData.planBackList" border>
          <el-table-column prop="planBackDate" label="计划回款日期">
            <template v-slot="{ row, $index }">
              <el-form-item v-if="row.edit" :show-message="false" inline-message :prop="`planBackList.${$index}.planBackDate`"
                :rules="[{ required: true, message: '请选择计划回款日期' }]">
                <el-date-picker v-model="row.planBackDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择计划回款日期"></el-date-picker>
              </el-form-item>
              <span v-else>{{ row.planBackDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="planBackAmount" label="计划回款额（元）">
            <template v-slot="{ row, $index }">
              <el-form-item v-if="row.edit" inline-message :prop="`planBackList.${$index}.planBackAmount`"
                :rules="[{ required: true, message: '请输入计划回款额' }]">
                <el-input v-model="row.planBackAmount" placeholder="请输入计划回款额"></el-input>
              </el-form-item>
              <span v-else>{{ row.planBackAmount }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item prop="fileList" label="合同文件">
        <file-upload readonly disabled v-model="formData.fileList" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
      </el-form-item>
      <el-form-item>
        <el-button @click="$router.back()">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'
export default {
  name: 'YhContractDetails',
  components: {
    FileUpload
  },
  data() {
    return {
      maintainLevelList: [],
      formData: {
        projectId: '',// 项目ID
        startDate: '',// 劳务开始日期
        contractName: '',// 合同名称
        endDate: '',// 劳务结束日期
        contractAmount: '',// 合同金额
        maintainLevel: '',// 养护等级(字典类型maintainLevel)
        planBackList: [], // 回款计划列表
        // planBackList[].planBackDate: '',// 计划回款日期
        // planBackList[].planBackAmount: '',// 计划回款金额
        fileList: [] // 附件列表
      }
    }
  },
  computed: {
    contractId() {
      return this.$route.query.contractId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.operate.selectContractByContractId, {
        contractId: this.contractId
      }).then((res) => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">
.plan {
  ::v-deep {
    .el-form-item {
      margin-bottom: 0;

      .el-input {
       width: 100% !important;
     }
    }
  }
}
</style>
